import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';

/**
 * A feature flag to guard development and testing of the activity injection.
 * @returns true if https://tools.coursera.org/epic/experiment/xem6tABXEfGgRA4nU0VIYQ is enabled.
 */
export const isActivityInjectionEnabled = (): boolean => {
  return LceCourseExperienceExperiments.get('isActivityInjectionEnabled') === true;
};
